/**
 * The entry point that is neither a player, a facilitator, nor a display.
 *
 * §5.3 — a player who lands here goes straight to the join screen; there is no
 * mode selection inside the player experience itself.
 */

import { Link } from "react-router-dom";

export function Landing(): React.ReactElement {
  return (
    <main className="tq-landing">
      <div style={{ textAlign: "center", maxWidth: 420 }}>
        <div style={{ color: "#8fb4ff", fontWeight: 800, fontSize: 12, letterSpacing: ".12em" }}>
          TRUSTEE QUEST
        </div>
        <h1 style={{ fontSize: 34, margin: "6px 0 22px", fontWeight: 900 }}>
          Live Trustee Showdown
        </h1>

        <Link
          to="/join"
          style={{
            display: "block",
            background: "var(--blue)",
            color: "#fff",
            padding: "16px 22px",
            borderRadius: "var(--radius-sm)",
            fontWeight: 800,
            textDecoration: "none",
            fontSize: 17,
            minHeight: 56,
          }}
        >
          I'm here to play
        </Link>

        {/*
          A button now rather than a small underlined link, because the console
          is a real destination and people arrive looking for it. It stays
          visibly secondary: nearly everyone who reaches this screen is a
          player, and giving the two equal weight would make a room of players
          stop and read before finding theirs.
        */}
        <Link
          to="/host"
          style={{
            display: "block",
            marginTop: 12,
            background: "transparent",
            border: "1px solid rgba(255,255,255,.28)",
            color: "#cfe0ff",
            padding: "14px 22px",
            borderRadius: "var(--radius-sm)",
            fontWeight: 700,
            textDecoration: "none",
            fontSize: 15,
            minHeight: 52,
          }}
        >
          I'm the facilitator
        </Link>

        <p style={{ marginTop: 18, fontSize: 12, color: "#8fa5cc", lineHeight: 1.6 }}>
          Both sign in with a code we email you. No password to remember.
        </p>
      </div>
    </main>
  );
}
